// @flow

import React, { Fragment } from 'react';

import { Grid, Row, Col } from 'clark-styles';

import { type EngagementsType } from 'types/engagements';
import { type ClientsType } from 'types/clients';
import { type SubjectsType } from 'types/subjects';
import { type SessionsType } from 'types/sessions';

import SessionsViewForm from 'containers/sessions/view-form';
import SessionsViewReportDetails from 'components/sessions/view/report-details';
import SessionsViewHeader from 'components/sessions/view/header';

import { getEngagementClientDetails } from 'utils/helpers/engagements';
import { hasSessionReport } from 'utils/helpers/sessions';
import { isSessionReportRatingEnabled } from 'utils/helpers/sessions/business-settings';

import { NotFound } from './styles';

type PropsType = {
  sessions: SessionsType,
  sessionId: string,
  tutoringEngagements: EngagementsType,
  clients: ClientsType,
  subjects: SubjectsType,
  business: {
    id: string,
  },
};

const SessionView = ({
  sessions,
  sessionId,
  tutoringEngagements,
  clients,
  subjects,
  business: { id: businessId },
}: PropsType) => {
  const session = sessions[sessionId];

  if (!session) return <NotFound>Session not found!</NotFound>;

  const {
    attributes: {
      status,
      tutoringEngagementId,
      sessionReportBody,
      internalNotes,
      sessionReportRating,
    },
  } = session;

  const engagement = tutoringEngagements[tutoringEngagementId];
  const { clientName } = getEngagementClientDetails(engagement, clients);

  const showSessionReportRating = isSessionReportRatingEnabled(businessId);

  return (
    <Fragment>
      <SessionsViewHeader
        session={session}
        sessions={sessions}
        clients={clients}
        engagements={tutoringEngagements}
        subjects={subjects}
      />
      <Grid>
        <Row>
          <Col sm={12} mdOffset={3} md={6} lg={6} lgOffset={3}>
            {hasSessionReport(session) ? (
              <SessionsViewReportDetails
                sessionReportRating={sessionReportRating}
                internalNotes={internalNotes}
                sessionReportBody={sessionReportBody}
                showSessionReportRating={showSessionReportRating}
              />
            ) : (
              <SessionsViewForm
                clientName={clientName}
                sessionId={sessionId}
                sessionStatus={status}
                showSessionReportRating={showSessionReportRating}
              />
            )}
          </Col>
        </Row>
      </Grid>
    </Fragment>
  );
};

export default SessionView;



// WEBPACK FOOTER //
// ./src/components/sessions/view/index.js